import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { I18nService } from '@eui/core';

@Component({
    standalone: false,
    templateUrl: './forbidden.component.html',
    styleUrls: ['./forbidden.component.scss']
})
export class ForbiddenComponent implements OnInit {

    currentLanguage$: Observable<string>;

    constructor(private i18nService: I18nService) { }

    ngOnInit() {
        this.currentLanguage$ = this.i18nService.getState('activeLang');
    }
}
